<script setup>
  import {defineProps} from "vue"
  defineProps({
    carouselItem:{
      type: Object,
      default(){
      return {src:'https://citesainteaugustine-ci.com/img/slide_two.895abca2.jpg',title:'Cité Sainte Augustine',description:'Vous souhaite la bienvenue'}
      }}
  });
</script>

<template>
  <li><!-- Slideshow Item #1 -->
    <div class="uk-position-cover uk-animation-kenburns uk-animation-reverse uk-transform-origin-bottom-center">
      <img :src="carouselItem?.slideImage?.url" alt="" data-uk-cover="height:319px">
      <div class="uk-overlay-primary uk-position-cover impx-overlay dark"></div>
    </div>
    <div class="uk-container uk-position-relative uk-height-1-1">
      <div class="uk-position-left uk-flex uk-flex-middle">
        <div class="impx-slide-fw-caption">
          <div class="impx-slide-fw-caption-outline uk-transition-slide-left"></div>
          <h1 class="uk-margin-remove impx-text-shadow uk-transition-slide-top uk-text-left">{{carouselItem.title}}</h1>
          <p class="impx-text-large impx-text-red-csa uk-margin-remove csa-mt-2 impx-text-shadow uk-transition-slide-bottom uk-text-right uk-text-uppercase">{{carouselItem.subtitle}}</p>
        </div>
      </div>
    </div>
  </li><!-- Slideshow Item #1 End -->
</template>

<style scoped>

</style>